<template>
  <div class="Main">
    <van-nav-bar
        fixed
        :border="false"
        :title="$t('message[0]')"
        left-arrow
        @click-left="$router.go(-1)"
    />
    <div class="PageBox">
      <div class="ScrollBox">
        <van-cell size="large" :title="item.title" is-link v-for="item in messageList" :key="item.id" @click="openShow(item)" />
        <van-empty :description="$t('message[1]')" v-if="!messageList" />
      </div>
    </div>
    <van-popup v-model="showCon" position="bottom" closeable close-on-popstate  style="width: 100%;height: 100%;background-color:rgb(255, 255, 255);color:#fff;">
      <div class="ScrollBox" style="padding: 16px 20px;">
        <h3 style="text-align: center;margin-bottom: 20px;color:#333">{{infoData.title}}</h3>
        <div class="Content" style="text-align: justify;color:#333" v-html="infoData.content"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'message',
  components: {
  },
  props: [],
  data() {
    return {
      showCon: false,
      infoData: '',
	  messageList:''
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
	 this.$Model.GetMessage(data=>{
		 this.messageList = data;
	 });
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    openShow(data) {
      this.showCon = true
      this.infoData = data
	  this.$Model.setMessage({mid:data.id})
    }
  }
}
</script>
<style scoped>
.Content ::v-deep img{
  max-width: 100%;
}
::v-deep .van-nav-bar__title{
	color: #fff;
}
</style>